/**
 * @flow
 * @author: VaraKumar
 */

import React, { Component } from 'react'

import VideoComponentModal from '../../../../IbcArcade/VideoComponentModal'
import { IcPlay } from '../../../../../Icons'
import { TESTIMONIALS_VIDEO_ID } from '../../../../../constants/IbcArcadeConstants'
import {
  MainContainer,
  PlayButtonContainer,
  ThumbnailImgContainer,
  IconContainer,
  PlayButtonText,
  ThumbnailImgSection,
  ThumbnailVideo
} from './styledComponents'

class VideoTestimonial extends Component {
  constructor(props) {
    super(props)
    this.state = {
      videoPlayState: false
    }
  }

  playVideo = () => {
    // console.log('playVideo triggered')
    this.setState({
      videoPlayState: true
    })
  }

  closeVideoModal = e => {
    if (e) {
      e.stopPropagation()
    }
    // console.log('closeVideoModal triggered')
    this.setState({
      videoPlayState: false
    })
  }

  render() {
    const { videoPlayState } = this.state
    const {
      thumbnailUrl,
      videoId,
      excludeBottomMargin,
      videoAltText,
      isVideoThumbnail,
      thumbnailVideoUrl,
      id
    } = this.props
    return (
      <MainContainer
        id={id}
        onClick={this.playVideo}
        excludeBottomMargin={excludeBottomMargin}
      >
        {isVideoThumbnail ? (
          <ThumbnailVideo
            autoPlay
            muted
            loop
            poster={thumbnailUrl}
            data-keepplaying
            id="mautic-player-0"
            className="videoImage"
          >
            <source src={thumbnailVideoUrl} type="video/webm" />
          </ThumbnailVideo>
        ) : (
          <ThumbnailImgSection>
            <ThumbnailImgContainer
              alt={videoAltText}
              draggable={false}
              dataSrc={thumbnailUrl}
              className="lazyload"
            />
            <PlayButtonContainer>
              <IconContainer>
                <IcPlay />
              </IconContainer>
              <PlayButtonText>Play&nbsp;Video</PlayButtonText>
            </PlayButtonContainer>
          </ThumbnailImgSection>
        )}

        <VideoComponentModal
          isOpen={videoPlayState}
          close={this.closeVideoModal}
          videoId={videoId}
        />
      </MainContainer>
    )
  }
}

VideoTestimonial.defaultProps = {
  thumbnailUrl: '',
  videoId: TESTIMONIALS_VIDEO_ID
}

export default VideoTestimonial



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/TestimonialComponents/VideoTestimonial/index.js